import React from "react";
import { useTranslation } from "react-i18next";

// Components

// Styles
import styles from "./segmented.module.css";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";

interface SegmentedProps {
  options: { value: any; label: string }[];
  value: any;
  onChange: (value: any) => void;
  className?: string;
}

const Segmented: React.FC<SegmentedProps> = ({ options = [], value, onChange, className }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`${styles.segmented} hidden md:flex flex-row gap-1 bg-gray-200 rounded-full dark:bg-stone-650 hover:shadow-md dark:hover:shadow-active_dark ${className}`}
      role="group"
      aria-label={t("segmented.aria_label")}
    >
      {options.map((option) => {
        const isSelected = value === option.value;
        const buttonStyles = isSelected ? 'text-blue-500 bg-white shadow-md dark:text-white  dark:bg-stone-650 hover:dark:shadow-active_dark' : 'text-gray-500 dark:text-gray-400 hover:scale-[1.01]';

        return (
          <button
            key={option.value}
            type="button"
            className={`flex flex-1 items-center justify-center hover:shadow-3xs hover:shadow-blue-500  dark:bg-stone-650 dark:hover:shadow-active_dark transition-all duration-300 ${buttonStyles} px-4 py-2 rounded-full text-sm md:text-base`}
            aria-pressed={value === option.value}
            onClick={() => onChange && onChange(option.value)}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  );
};

export default Segmented;
